<template>
  <div>
    <api-loading :show="loading"></api-loading>
    <LeftSide
      :leftStatus="leftSideStatus"
      :msgStatus="msgStatus"
      :distributorName="distributorName"
      :status="status"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :msgStatus="msgStatus"
        :status="status"
        :distributorName="distributorName"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('Consult.findBySupplier')"
        :items="items"
        :first_loading="firstLoading"
        @openModalMessage="openModalMessage"
      />
      <no-rights v-else></no-rights>
      <pagination
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/message/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
    </div>
    <ModalMessage :open="modalMessage.open" :dId="modalMessage.dId" />
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components/Modal";
import { pagination } from "@components/pagination.js"; //分页
import ModalMessage from "./message"; //留言弹层
export default {
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: false,
      firstLoading: true,
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("message-rowsPerPage"))
        ? parseInt(store.get("message-rowsPerPage"))
        : 10,
      pageSizeSelect: [10, 20, 50],
      totalPage: 0,
      totalCount: 0,
      distributorId: "",
      distributorName: "",
      status: "",
      items: [],
      modalMessage: {
        open: Symbol(),
        dId: "",
      },
      msgStatus: {
        2: this.$t("mall.未读"),
      },
    };
  },
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
    ModalMessage,
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("message-rowsPerPage", this.rowsPerPage);
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
  },
  methods: {
    clearKey(type) {
      console.log(type);
      if (type == "name") {
        this.distributorId = "";
        this.distributorName = "";
      } else {
        this[type] = "";
      }
      this.toPage(1);
    },
    filtrate(status, distributorName, distributorId) {
      this.status = status;
      this.distributorName = distributorName;
      this.distributorId = distributorId;
      //筛选都回第一页
      this.toPage(1);
    },
    openModalMessage(item) {
      this.modalMessage.dId = item.distributorId;
      this.modalMessage.open = Symbol();
      $("#modalMessage").modal("show");
    },
    getItems() {
      if (!this.isSysRights("Consult.findBySupplier")) return;
      this.loading = true;
      $.api_call(
        "api.Consult.findBySupplier",
        {
          page: this.page,
          rowsPerPage: this.rowsPerPage,
          status: this.status,
          distributorId: this.distributorId,
        },
        (r) => {
          this.loading = false;
          this.firstLoading = false;
          if (r.ErrorCode == "9999") {
            this.items = [];
            this.totalCount = r.Data.Pagination.totalCount;
            this.totalPage = r.Data.Pagination.totalPage;
            r.Data.Results.forEach((e) => {
              this.items.push(e);
            });
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/message/" + 1 });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({ path: "/message/" + num });
      if (page == num) {
        this.getItems();
      }
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
  },
};
</script>